export default __webpack_public_path__ + "static/media/html_pricing_community.96853043.md";